<!-- Navigation menu (toolbar) -->
<app-video-handler *ngIf="isVideoChatAvailable()"></app-video-handler>
<app-nav></app-nav>
<!-- Container (components)-->
<router-outlet></router-outlet>
<!-- Footer
<app-footer></app-footer>-->
